import React from 'react'
import { Link, IndexLink, withRouter } from 'react-router'
import styles from './SideNav.scss'
import { withCollapseState, withToggleCollapse } from '../SideNavContexts'
import { Topo } from 'common/styleguide/Topo'
import { Icon } from 'common/Icon'
import { fm } from 'lib/localization'
import cx from 'classnames'
import { defineMessages, injectIntl } from 'react-intl'

const sideNavMessages = defineMessages({
  collapse: {
    id: 'sideNavMessages.collapse',
    defaultMessage: 'Collapse Menu'
  }
})

export class _SideNav extends React.PureComponent {
  render () {
    const {
      toggleCollapse,
      collapseState, // SideNavLayout collapse state
      links,
      children,
      location,
      intl
    } = this.props

    const linkArray = Array.isArray(links)
      ? links // it's an array, use it
      : links({ collapseState }) // it's a render function, call it

    const childArr = React.Children.toArray(children)

    const childOfType = Type => {
      // see https://github.com/gaearon/react-hot-loader#checking-element-types
      const realType = <Type />.type
      return childArr.find(c => c.type === realType)
    }

    const header = childOfType(SideNavHeader)
    const navExtras = childOfType(SideNavExtras)
    const navActions = childOfType(SideNavActions)

    const topClassName = cx(
      styles.SideNavLayout,
      !collapseState && styles.notCollapsed,
      collapseState === 'viewport' && styles.viewportCollapse,
      collapseState === 'user' && styles.userCollapse
    )

    const activeLink = (
      linkArray.find(l => l.index ? location.pathname === l.to : location.pathname.startsWith(l.to)) || linkArray[0]
    )

    const sidebarMode = (!collapseState) || (collapseState === 'user')

    return (
      <div className={topClassName}>

        {sidebarMode && header}

        {(collapseState === 'viewport' || collapseState === 'viewport-expanded') &&
          <a
            className={cx(styles.SideNavLink, styles.SideNavLinkActive, styles.mobileNavTrigger)}
            onClick={toggleCollapse}>
            <Icon i={activeLink.icon} size={20} className={styles.icon} />
            <span className={styles.text}>{activeLink.title}</span>
            <Icon i={collapseState === 'viewport' ? 'ios-arrow-down' : 'ios-arrow-up'} size={20} className={cx(styles.icon, styles.triggerIcon)} />
          </a>}

        {collapseState !== 'viewport' && <SideNavLinks
          linkArray={collapseState !== 'viewport-expanded' ? linkArray : linkArray.filter(l => l !== activeLink)}
          collapseState={collapseState} />}

        {(sidebarMode || collapseState === 'viewport-expanded') && navExtras}

        {collapseState !== 'viewport' && <div className={styles.navActions}>
          {sidebarMode && <SideNavAction
            i={`md-arrow-drop${collapseState === 'user' ? 'right' : 'left'}-circle`}
            label={fm(intl, sideNavMessages.collapse)}
            onClick={toggleCollapse} />}
          {navActions}
        </div>}
      </div>
    )
  }
}
export const SideNav = withRouter(withToggleCollapse(withCollapseState(injectIntl(_SideNav))))

class SideNavLinks extends React.PureComponent {
  render () {
    const { linkArray, collapseState } = this.props
    return <div className={styles.SideNavLinks} id='side-nav-links'>
      {linkArray.map(l => (
        <SideNavLink
          collapseState={collapseState}
          key={l.title}
          children={l.title}
          to={l.to}
          href={l.href}
          i={l.icon}
          id={l.id}
          index={l.index} />
      ))}
    </div>
  }
}

export class SideNavHeader extends React.PureComponent {
  render () {
    const {
      children,
      collapseState,
      ...props
    } = this.props
    return (
      <Topo {...props} dark className={styles.SideNavHeader}>
        {children}
      </Topo>
    )
  }
}

class _SideNavAction extends React.PureComponent {
  render () {
    const { label, i, collapseState, ...props } = this.props
    return (
      <a {...props} className={cx(styles.SideNavAction, i && styles.hasIcon)}>
        {i && <Icon i={i} size={18} />}
        {collapseState !== 'user' && <span className={styles.label}>{label}</span>}
      </a>
    )
  }
}
export const SideNavAction = withCollapseState(_SideNavAction)

export class SideNavLink extends React.PureComponent {
  render () {
    const { id, title, index, i, collapseState, children, ...props } = this.props
    const L = index
      ? IndexLink
      : Link

    // We use the key attribute to force the actual DOM element to be re-created
    // when the tooltip<>not-tooltip state changes here. This prevents the hanging
    // tippy references from tooltipping links that should not have tooltips
    return collapseState === 'user'
      ? (
        <L key='hasTooltip' id={id} {...props} className={styles.SideNavLink} data-tip activeClassName={styles.SideNavLinkActive} title={children} data-tippy-placement='right'>
          <Icon i={i} size={20} className={styles.icon} />
        </L>
      )
      : (
        <L key='noTooltip' id={id} {...props} className={styles.SideNavLink} activeClassName={styles.SideNavLinkActive}>
          <Icon i={i} size={20} className={styles.icon} /><span className={styles.text}>{children}</span>
        </L>
      )
  }
}

export class SideNavExtras extends React.PureComponent {
  render () {
    const {
      children,
      collapseState,
      ...props
    } = this.props
    return (
      <div {...props} className={styles.SideNavExtras}>
        {children}
      </div>
    )
  }
}

export class SideNavActions extends React.PureComponent {
  render () {
    return this.props.children
  }
}
